import React from 'react';
import cs from 'classnames';
import keyBy from 'lodash/keyBy';
import {connect} from 'react-redux';

import LabeledInput from '~/components/common/LabeledInput';
import DropDown from '~/components/common/DropDown';
import {MenuList, MenuListItem} from '../MenuList';
import {brokersDataPreview, matchBroker, getBrokerName, getBrokerDescName} from '~/misc/brokers';
import resourceId, {getResource} from '~/misc/resourceId';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';

const resource = resourceId('brokers-search-data', {});

const ItemsList = ({selectedValues, selectedValuesIndex, values, limit, handleToggle, brokersData}) =>
  (<div>
    {values.map(i => {
      const full = limit ? (selectedValues.length === limit) : false;
      const selected = selectedValuesIndex[i];
      const disabled = full && !selected;

      const name = getBrokerName(brokersData, i);
      const descName = getBrokerDescName(brokersData, i);

      let props = {
        data: i,
        title: <span className={css.matchedItem}>
          <span className={css.generalName}>{name}</span>
          {descName && <span className={css.descName}>{descName}</span>}
        </span>,
        selected: selected,
        disabled: disabled,
        fn: !disabled && handleToggle,
        multi: true,
      };

      return (
        <MenuListItem
          {...props}
          key={i}
          data-qa={`item-${i.toLowerCase()}`}
        />);
    })}
  </div>);

class BrokersInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleAny = this.handleAny.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onSelectBroker = this.onSelectBroker.bind(this);
    this.state = {
      emailPopSwitch: Boolean(props.emailPopSwitch),
    };
  }

  render() {
    const props = this.props;
    const brokersData = this.props.brokersData;

    const selectedValues = props.value || props.initialValue;
    const selectedValuesIndex = keyBy(selectedValues);
    const handleAny = this.handleAny;
    const handleToggle = this.handleToggle;

    const state = this.state;

    const matched = (state && state.query && state.matched);
    const matchedBrokers = (matched && matched.list) || brokersDataPreview.sorted.slice(0, 7);
    const matchedCount = matched ? matched.total : null;

    const mark = selectedValues.length ? selectedValues.map(item => getBrokerName(brokersData, item)) : ['Any'];

    const limit = 7;

    const queryValue = (this.state && this.state.query) || '';
    return (
      <DropDown
        id={props.dropDownId}
        allowKeyboard={true}
        trigger={
          <LabeledInput
            value={mark}
            data-qa='qa-brokers'
            readOnly={true}
            label='Brokers'
            icon='plus'
            capitalize={true}
            mediumInput
            onSelectBroker={this.onSelectBroker}
          />
        }
        wrapClassName={cs(props.wrapClassName, 'qa-brokers-input')}
        // content= {!state.emailPopSwitch && (<div>
        content= {(<div>
          <div className={css.inputWrap}>
            <input
              className={css.input}
              type='search'
              autoFocus={true}
              value={queryValue}
              onInput={this.handleSearch}
              placeholder='Type broker name or DOT number'
            />
          </div>
          <MenuList multi={true}>
            <MenuListItem
              fn={handleAny}
              title='Any'
              selected={!selectedValues.length}
              data-qa={'item-any'}
            />
            <ItemsList
              selectedValues={selectedValues}
              selectedValuesIndex={selectedValuesIndex}
              values={matchedBrokers}
              limit={limit}
              handleToggle={handleToggle}
              brokersData={brokersData}
            />
          </MenuList>
          <div className={cs(css.desc, css.searchPartBottom)}>
            {matchedBrokers.length}{matchedCount ? `/${matchedCount}` : null} of more than 500 our major brokers
          </div>
          {selectedValues.length ? <div className={css.selectedBlock}>
            <div className={css.desc}>
                You can select up to 15 brokers
            </div>
            <MenuList multi={true}>
              <ItemsList
                selectedValues={selectedValues}
                selectedValuesIndex={selectedValuesIndex}
                values={selectedValues}
                limit={15}
                handleToggle={handleToggle}
                brokersData={brokersData}
              />
            </MenuList>
          </div> : null}

        </div>)}
        data-qa={props.isLoggedIn}
      />
    );
  }

  randomShowPop(data) {
    const {emailPopRate, emailPopSwitch, user} = data;
    // service close switch close verify pop
    if (!emailPopSwitch) {
      return false;
    }

    // profile msg incomplete
    if (user.emailVerified && user.firstName && user.lastName && user.phone
      && (user.verify_result)
    ) {
      return false;
    }

    // random open verify pop rate
    const randow1 = Math.round(Math.random() * 100);
    return randow1 < emailPopRate;
  }

  onSelectBroker(e) {
    e.preventDefault();
    const data = this.props;
    const openPop = this.randomShowPop(data);
    const {accountLevel, free} = data.account;
    const judgeMember = () => {
      if (parseInt(accountLevel) > parseInt(free)) {
        return true;
      }
      return false;
    };

    this.setState({
      emailPopSwitch: openPop,
    });
    if (data.emailPopSwitch && !data.isLoggedIn) {
      return data.login();
    }

    if (!judgeMember()) {
      return this.props.showUpgradeToStandard();
    }

    if (openPop) {
      return data.showDownloadAppAndSendEmail();
    }
    return null;
  }

  handleSearch(e) {
    const value = e.target.value;
    this.setState({query: value, matched: matchBroker(this.props.brokersData, value, 10)});
  }

  handleAny() {
    return this.props.onChange([]);
  }

  handleToggle(e) {
    const toggledValue = e.currentTarget.getAttribute('data-value');
    const selectedValues = this.props.value || this.props.initialValue;
    const selectedValuesIndex = keyBy(selectedValues);

    if (selectedValuesIndex[toggledValue]) {
      this.props.onChange(selectedValues.filter(i => i !== toggledValue));
    } else {
      this.props.onChange([...selectedValues, toggledValue]);
    }
  }
}


export default connect((state) => {
  const isLoggedIn = state.user.isLoggedIn;
  const user = state.user;
  const emailPopSwitch = state.dots.mainSwitch.data.email_switch.switch;
  const emailPopRate = state.dots.mainSwitch.data.email_switch.chance;

  const data = getResource(state, resource);

  return {
    brokersData: (data && data.item) || null,
    isLoggedIn,
    emailPopSwitch,
    emailPopRate,
    user,
    account: state.account,
  };
}, mapDispatch({
  login: () => modalChange(modes.LOGIN, 'dashboard'),
  dotPop: () => modalChange(modes.DOT_VALIDATE, 'dashboard'),
  showUpgradeToStandard: (props) => modalChange('pop', {
    source: 'brokersInput',
    type: 'pop_upgrade_to_standard',
  }),
  showDownloadAppAndSendEmail: (props) => modalChange('pop', {
    source: 'brokersInput',
    type: 'pop_download_and_send_verify_email',
  }),
}))(BrokersInput);



// WEBPACK FOOTER //
// ./src/components/common/BrokersInput/index.js